/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Youtube_Export_Open_ProfileInputs */

const cs_youtube_export_open_profile = /** @type {(inputs: Youtube_Export_Open_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otevřít profil`)
};

const en_youtube_export_open_profile = /** @type {(inputs: Youtube_Export_Open_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open profile`)
};

/**
* | output |
* | --- |
* | "Open profile" |
*
* @param {Youtube_Export_Open_ProfileInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const youtube_export_open_profile = /** @type {((inputs?: Youtube_Export_Open_ProfileInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Youtube_Export_Open_ProfileInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_youtube_export_open_profile(inputs)
	return cs_youtube_export_open_profile(inputs)
});